
import { buildFixedSrcSet, buildSrc } from '@Utils/images';

export default {
  name: 'EditoPush',
  props: {
    /**
     * Name of image doodle
     * @see elements/doodle-image
     */
    doodle: {
      type: String,
      default: undefined,
    },
    /**
     * Push image
     * @property {string} alt Image alt
     * @property {string} src Image src
     * @property {string} type Image type (dam or static)
     */
    img: {
      type: [Object, String],
      default: undefined,
    },
    /**
     * Push text
     */
    text: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    imgAttributes() {
      if (!this.img) {
        return undefined;
      }
      return {
        alt: this.img.alt || '',
        height: 136,
        loading: 'lazy',
        src: buildSrc({
          img: this.img,
          width: 136,
        }),
        srcset: buildFixedSrcSet({
          img: this.img,
          width: 136,
        }),
        width: 136,
      };
    },
  },
};
